module.exports = {
  APPLICATION: 1,
  COMPLETED: 2,
  REVIEW: 3,
  SUBMITTED: 4
};


/*****************
 ** WEBPACK FOOTER
 ** ./js/shared/utils/application-stages.js
 ** module id = 245
 ** module chunks = 0 1 6
 **/